<template>
    <v-container class="px-0" fluid v-show="innerShouldShow">
        <v-alert
            v-if="!innerIsReview"
            :border="alertBorder"
            :color="alertColor"
            :type="alertType"
            :dismissible="dismiss"
            >{{ directions }}</v-alert
        >
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
            </type-review>
        </div>
    </v-container>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';

export default {
    name: 'TypeAlertMessage',
    mixins: [formMixin],
    components: {
        TypeReview
    },
    props: {
        field: {
            type: Object,
            default: () => {}
        }
    },
    mounted() {
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                // label: this.innerLabel,
                directions: this.directions
            };
        },
        alertBorder() {
            return this.vProps.alert_border ? this.vProps.alert_border : null;
        },
        alertColor() {
            return this.vProps.alert_color ? this.vProps.alert_color : null;
        },
        dismiss() {
            return this.vProps.dismissible ? this.vProps.dismissible : null;
        },
        alertType() {
            return this.vProps.alert_type ? this.vProps.alert_type : null;
        }
    }
};
</script>
